import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { FlagProvider } from '@unleash/proxy-client-react';
import { Suspense, type PropsWithChildren } from 'react';

import { IntercomProvider } from './intercom.provider';
import { SentryErrorBoundary, SentryProvider } from './sentry.provider';

import { unleashConfig } from '@/configs/unleash.config';
import { AuthProvider } from '@/features/auth/auth';
import { queryClient } from '@/query-client';
import { GoogleTagManagerProvider } from '@/shared/providers/gtm.provider';

export const AppProviders = ({ children }: PropsWithChildren) => (
  <Suspense>
    <SentryProvider>
      <SentryErrorBoundary>
        <FlagProvider config={unleashConfig}>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <GoogleTagManagerProvider>
                <IntercomProvider>
                  {children}
                  {import.meta.env.DEV && (
                    <ReactQueryDevtools initialIsOpen={false} />
                  )}
                </IntercomProvider>
              </GoogleTagManagerProvider>
            </AuthProvider>
          </QueryClientProvider>
        </FlagProvider>
      </SentryErrorBoundary>
    </SentryProvider>
  </Suspense>
);
